import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import ActionLinkTop from '../../components/common/ActionLinkTop';
import CountTop from '../../components/common/CountTop';
import Panel from '../../components/common/Panel';
import Wall from '../../components/common/Wall';
import DropDownFilter from '../../components/filters/DropDownFilter';
import SortOrderFilter from '../../components/filters/SortOrderFilter';
import { productsFilter } from '../../constants/filters';
import {
  productsDropshipCheckAll,
  productsDropshipCheckAllOnPage,
  productsDropshipUncheckAll,
  setProductsDropshipOrder,
  setProductsDropshipOrderField,
} from '../../store/actions/productsDropship';
import { BlockSelectAllModal } from '../../components/common/SelectAllModal';
import { MAX_ITEMS_TO_SELECT_ALL } from '../../components/common/SelectAllModal/consts';

export function ProductsDropshipPagePanel() {
  const dispatch = useDispatch();
  const { data: products, checked, count } = useSelector((state) => state.productsDropship);
  const productsCount = Number(count);
  const selectedCount = Object.keys(checked).length;
  const [shouldOpenSelectAllModal, setShouldOpenSelectAllModal] = useState(false);

  useEffect(() => {
    return () => {
      dispatch(productsDropshipUncheckAll);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const selectAllOnPage = () => {
    const selected = {};
    products?.forEach((item) => {
      selected[item.model] = item.variants;
    });
    dispatch(productsDropshipCheckAllOnPage(selected));
  };

  const handleSelectAll = () => {
    if (count > MAX_ITEMS_TO_SELECT_ALL) {
      setShouldOpenSelectAllModal(true);
    } else dispatch(productsDropshipCheckAll());
  };

  return (
    <>
      <Panel>
        <Wall />
        <CountTop title="All" count={productsCount} />
        <CountTop title="Selected" count={selectedCount} />
        <Wall />
        <ActionLinkTop title="Select this page" onClick={selectAllOnPage} />
        <ActionLinkTop title="Select all" onClick={() => handleSelectAll()} />
        <ActionLinkTop title="Unselect all" onClick={() => dispatch(productsDropshipUncheckAll)} />
        <Wall />
        <DropDownFilter
          values={productsFilter}
          onChange={(field) => dispatch(setProductsDropshipOrderField(field))}
          staticPoint
        />
        <Wall />
        <SortOrderFilter onChange={(order) => dispatch(setProductsDropshipOrder(order))} />
        <Wall />
      </Panel>
      <BlockSelectAllModal open={shouldOpenSelectAllModal} onClose={() => setShouldOpenSelectAllModal(false)} />
    </>
  );
}
